// extracted by mini-css-extract-plugin
export default {"pageError":"Error404_pageError__XVIu3","Err404":"Error404_Err404__wguHX","textError":"Error404_textError__mC+lz","saut":"Error404_saut__1UMAr","lien":"Error404_lien__ZRwPY"};